import React from "react";
import { useSiteRentalPaymentFrequenciesQueryQuery} from "../../generated/graphql";
import {GraphQlSelect} from "./GraphQlSelect";

export const SiteRentalPaymentFrequencySelect = (props) => {
    const query = useSiteRentalPaymentFrequenciesQueryQuery();
    return <GraphQlSelect {...props} queryResult={query} labelField="label"/>;
}

